import React, { useEffect } from 'react';
import MovingImageProps from './properties/movingImageProps';
import { generateUniqueId } from './videoPlaylist';

interface VideoProps {
  videoId: string;
  movingImage: MovingImageProps;
  onVideoEnded: (event: Event | null, force?: boolean | undefined) => any;
  playTrigger: number;
  muted?: boolean
}

declare global {
  interface Window {
    VideoPlayer: any;
  }
}

const Video = React.forwardRef<HTMLDivElement,VideoProps>((props,  ref) => {
  const { movingImage, videoId, onVideoEnded, playTrigger, muted } = props;
  const containerId = `videoPlayer_${videoId}`
  // Initial initialization
  useEffect(() => {
    const miApi = window.VideoPlayer;
    const miInitParameters = {
      success(playerApi: any) {
        muted && playerApi.toggleMute();
        playerApi.registerEventListener('ended', onVideoEnded);
      },
      parameters: {
        configType: movingImage.configType,
        playerId: movingImage.playerId,
        videoId,
        apiUrl: movingImage.apiUrl,
        flashPath: movingImage.flashPath,
      },
    };
    try {
      const player = miApi.Collection.getPlayerById(containerId);
      // reattach event, otherwise react has issues working with movingimage
      player.unregisterEventListener('ended', onVideoEnded);
      player.registerEventListener('ended', onVideoEnded);
      player.switchVideo(videoId);
    } catch {
      // getPlayerById throws an exception. In this case initialize player
      try {
        miApi.Collection.addPlayerById(containerId, miInitParameters);
      } catch {
        /* no error handling required */
      }
    }
  }, [movingImage, videoId, onVideoEnded, containerId]);

  useEffect(() => {
    const miApi = window.VideoPlayer;
    try {
      const player = miApi.Collection.getPlayerById(containerId);
      player.play();
    } catch {
      /* no error handling required */
    }
  }, [playTrigger]);
  return <div ref={ref} id={containerId} />;
});

export default Video;
